module.exports = __webpack_public_path__ + "img/Home-Icon.e36fd1b5.webp";